import { type ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update user logged main identity.
 *
 * @endpoint POST /api/me/identities/{auth0Id}/change_main_identity
 * @scope shared
 * @see https://flecto.dev/api-5836476
 */
export async function changeUserMainIdentity(auth0Id: ParameterID) {
  await api.post(`/api/me/identities/${auth0Id}/change_main_identity`)
}
